import { render, staticRenderFns } from "./RewardLadder.vue?vue&type=template&id=7fa6fae4&scoped=true"
import script from "./RewardLadder.vue?vue&type=script&lang=js"
export * from "./RewardLadder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa6fae4",
  null
  
)

export default component.exports